<template>
    <div id="skuUpcSearch">
        <a-modal
            :title="$t('skuSearch.upcSearch')"
            :visible="visible"
                :zIndex="98"
            width="60%"
            @cancel="handleCancel"
            :maskClosable=false>
            
            <template slot="footer">                      
                 <a-button @click="searchSkuByUpc" class="mlt" size="small" type="primary" > <a-icon type="search" />{{ $t('skuSearch.search') }}</a-button>
            </template>

            <a-form :form="form" width="60%">
                  <a-row>
                    <a-col span="3" offset="1">
                        <a-form-item  class="rightAlign">
                            <b>{{$t('skuSearch.upc')}}</b>
                        </a-form-item>
                    </a-col>
                    <a-col span="10" offset="1">
                        <a-form-item>
                              <div   class="relative">
                                    <a-input
                                       size="small"
                                       placeholder="UPC"
                                       autocomplete="off"
                                       v-model="upc"
                                       style="width: 100%"
                                    />
                                </div>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>



    </div>
</template>



<script>
    //import ajax from '../../../../api/ajax'
   // import api from '../../../../api/url'
   // import popSku from '../skuSearch.vue'
    export default {
        components:{  
            //adjustmentSearch,
            //popSku
            
        },
        data(){
            return {
                visible: false,
                form: this.$form.createForm(this),
                actionSelect:[],
                upc:"",
                
            }
        },
        created(){
            //  this.show()
        },
       
        methods:{
            handleCancel(){
                this.visible = false
            },
            show(){
               this.form.resetFields();
               this.visible = true;
               this.upc = "";
            },
            searchSkuByUpc(){
                this.visible = false;

              /*  let paramData = {upc:""};

                if (this.upc != "") {
                    paramData.upc = this.upc;
                }
                let jsonString = JSON.stringify(paramData);
                this.$emit("skuUpcSearch", jsonString);*/
                this.$emit("skuUpcSearch", this.upc);
            },



        }
    }
</script>



<style>
   
   .rightAlign{
         text-align: right;
   }
</style>